import(/* webpackMode: "eager" */ "/workspace/app/stationaries/components/Products.jsx")